import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpEvent,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { ToasterService } from "../services/toaster.service";
import { environment } from "../../environments/environment";
import { AuthService } from "../services/auth.service";
import { CookieService } from "ngx-cookie-service";
import { Router } from "@angular/router";
import { mergeMap } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class InterceptorService implements HttpInterceptor {
  isLoggedIn: boolean = false;
  apiCallTimer: any;
  javaApiCallTimer:any;

  constructor(
    private toaster: ToasterService,
    private auth: AuthService,
    private cookieService: CookieService,
    private router: Router
  ) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.url.includes(environment.KUDOSHUB_BACKEND_HOST)) {
      if (localStorage.getItem("ev_key")) {
        req = req.clone({
          setHeaders: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            'ev-key': localStorage.getItem("ev_key"),
          },
        });
      }
      else {
        req = req.clone({
          setHeaders: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        });
      }
      // Add 25 minutes in current time
      this.apiCallTimer = new Date().getTime() + 25*60000;

    }
    else if (req.url.includes(environment.NOTIFICATION_BACKEND_HOST)) {
      req = req.clone({
        setHeaders: {
          "x-access-token": localStorage.getItem("notification_access_token"),
        },
      });
    } else {
        let currentTime = new Date().getTime();
        if (this.apiCallTimer < currentTime){
          // healthCheck call after 25 minutes of laravel Api
           return this.auth.healthCheck().pipe(mergeMap(res => {
            req = req.clone({
              setHeaders: {
                Authorization: "Bearer " + localStorage.getItem("ev_key"),
              },
            });
            return next.handle(req).pipe(
              catchError((err) => {
                if (err instanceof HttpErrorResponse) {
                  if (err.status === 410) {
                    this.auth.checkLogin();
                    this.auth.isUserLoggedIn.subscribe((val) => {
                      this.isLoggedIn = val;
                    });
                    if (this.isLoggedIn == true) {
                      this.logout();
                    } else {
                      return throwError(err);
                    }
                  }
                  if ((err.status === 401) && (req.url != environment.KUDOSHUB_BACKEND_HOST+"api/login")) {
                    localStorage.removeItem("access_token");
                    this.router.url.includes("/dashboard") ?
                    this.router.navigate(['/login'],{ queryParams: { 'redirectURL': this.router.url }})
                    : this.router.navigate(['/login'])
                    // location.reload();
                  }
                  return throwError(err);
                }
              })
            );
          }));
        }
        else {
          // Add 5 minutes in current time;
          this.javaApiCallTimer = new Date().getTime() + 5*60000;
          req = req.clone({
            setHeaders: {
              Authorization: "Bearer " + localStorage.getItem("ev_key"),
            },
          });
          // healthCheck call ones after 5 minutes of javaApi;
          setTimeout(() => {
            let currentTime = new Date().getTime();
            if (this.javaApiCallTimer > currentTime) {
              return;
            }
            else {
              this.auth.healthCheck().subscribe();
            }
          }, 5*60000)
        }
      }
    return next.handle(req).pipe(
      map((res: any) => {
        if (res.status === 200) {
          this.auth.redirectUrl = null;
        }
        return res;
      }),
      catchError((err) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 409) {
            this.toaster.show(
              "error",
              "Check it out!",
              "Sorry, Your Account is Temporary Inactive"
            );
          }
          if (err.status === 410) {
            this.auth.checkLogin();
            this.auth.isUserLoggedIn.subscribe((val) => {
              this.isLoggedIn = val;
            });
            if (this.isLoggedIn == true) {
              this.logout();
            } else {
              return throwError(err);
            }
          }
          if ((err.status === 401) && (req.url != environment.KUDOSHUB_BACKEND_HOST+"api/login") &&
          (req.url != environment.KUDOSHUB_BACKEND_HOST+"api/activate-user")) {
            localStorage.removeItem("access_token");
            if (this.auth.redirectUrl) {
              this.router.navigate(['/login'],{ queryParams: { 'redirectURL': this.auth.redirectUrl }});
              this.auth.redirectUrl = null;
            }
            else {
              this.router.url.includes("/dashboard") ?
              this.router.navigate(['/login'],{ queryParams: { 'redirectURL': this.router.url }})
              : this.router.navigate(['/login'])
            }
            // location.reload();
          }
            return throwError(err);
        }
      })
    );
  }

  logout() {
    this.auth.logout().subscribe(
      (res: any) => {
        if (res.status === 200) {
          localStorage.removeItem("access_token");
          // this.cookieService.deleteAll();
          this.auth.checkLogin();
          this.auth.isUserLoggedIn.subscribe((val) => {
            this.isLoggedIn = val;
          });
          this.router.navigate([""]);
          if ('KudosHub' in window && typeof window.KudosHub === 'function') {
            window.KudosHub('shutdown', {
              appId: "",
              email: "",
              name: "",
              created_at: 0
            });
          } else {
            console.log('KudosHub is not defined on the window object.');
          }
        }
      },
      (err: any) => {
        if (err.status === 401) {
          this.toaster.show(
            "error",
            "Check it out!",
            "There was a problem logging you out"
          );
        }
      }
    );
  }
}
